import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useDemo } from "@/context/DemoContext";
import { DemoBadge } from "@/components/DemoBadge";
import { FolderLock, Loader2, FileText, ListTodo, Users, ArrowRight } from "lucide-react";
import { PriorityBadge } from "@/components/PriorityBadge";

const eur = (v) => (v == null ? "—" : `€ ${Number(v).toLocaleString("it-IT")}`);

export default function DataRoom() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  const { showDemo } = useDemo();

  useEffect(() => { api.get("/dataroom", { params: { include_demo: showDemo } }).then((r) => setItems(r.data)).catch(() => setItems([])); }, [showDemo]);

  if (!items) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-[#EA7B2B]" /></div>;

  return (
    <div className="space-y-6" data-testid="dataroom-page">
      <div>
        <h1 className="text-3xl font-light text-white flex items-center gap-3"><FolderLock className="w-7 h-7 text-[#EA7B2B]" /> Data Room</h1>
        <p className="text-sm text-zinc-500 mt-1">{items.length} operazioni qualificate · documenti, attività e note per il team</p>
      </div>

      {items.length === 0 ? (
        <div className="text-sm text-zinc-500 bg-[#122A3F] border border-white/10 rounded-sm p-8 text-center">Nessuna operazione qualificata accessibile.</div>
      ) : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-3">
          {items.map((d) => (
            <button key={d.id} onClick={() => nav(`/dataroom/${d.id}`)} data-testid={`dataroom-card-${d.id}`}
              className="text-left bg-[#122A3F] border border-white/10 rounded-sm p-4 hover:border-[#EA7B2B]/50 transition-colors group">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="text-white font-medium truncate flex items-center gap-2">{d.comune}{d.is_demo && <DemoBadge />}</div>
                  <div className="text-xs text-zinc-500 truncate">{d.indirizzo || d.tipologia}</div>
                </div>
                <PriorityBadge level={d.priorita} />
              </div>
              <div className="flex items-center gap-3 mt-3 text-xs">
                <span className="text-zinc-400">Score <b className="text-white">{d.score ?? "—"}</b></span>
                <span className="text-zinc-400">ROI <b className="text-[#10B981]">{d.roi != null ? `${d.roi}%` : "—"}</b></span>
                <span className="text-zinc-400">{eur(d.valore)}</span>
              </div>
              <div className="flex items-center justify-between mt-3 pt-3 border-t border-white/5 text-[11px] text-zinc-500">
                <span className="flex items-center gap-3">
                  <span className="flex items-center gap-1"><FileText className="w-3.5 h-3.5" /> {d.n_documenti}</span>
                  <span className="flex items-center gap-1"><ListTodo className="w-3.5 h-3.5" /> {d.n_attivita}</span>
                  <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {d.autorizzati_nomi.length}</span>
                </span>
                <ArrowRight className="w-4 h-4 text-zinc-600 group-hover:text-[#EA7B2B] transition-colors" />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
